import clsx from "clsx";
import * as React from "react";
import { constrain } from "@spscommerce/utils";

import * as PropTypes from "../prop-types";
import { PropsType } from "../PropsType";
import { spsGlobalPropTypes } from "../util";

export const propTypes = {
    numPages: PropTypes.number,
    onPageChange: PropTypes.func,
    page: PropTypes.number,
    ...spsGlobalPropTypes
};

export type SpsPageSelectorProps = PropsType<typeof propTypes> &
    React.HTMLAttributes<HTMLDivElement>;

let idNum = 0;

export function SpsPageSelector(props: SpsPageSelectorProps) {
    const {
        numPages = 0,
        onPageChange,
        page: pageProp = 1,
        unsafelyReplaceClassName,
        className,
        "data-testid": testId,
        ...rest
    } = props;

    const [inputPage, setInputPage] = React.useState(pageProp);
    const [page, setPage] = React.useState(pageProp);

    React.useEffect(() => {
        setPage(pageProp);
        setInputPage(pageProp);
    }, [pageProp]);

    function updatePage(newPage: number) {
        newPage = constrain(newPage, [1, numPages]);

        if (newPage !== inputPage) {
            setPage(newPage);
            setInputPage(newPage);
            if (onPageChange && typeof onPageChange === "function") {
                onPageChange(newPage);
            }
        }
    }

    function onTextInputInput(event) {
        updatePage(parseInt(event.target.value, 10));
    }

    const classes = clsx(
        unsafelyReplaceClassName || "sps-page-selector",
        className,
    );

    const id = `sps-page-selector-${idNum++}`;

    return (
        <div className={classes} data-testid={testId} {...rest}>
            <div className="sps-pagination__input-wrapper" data-testid={`${testId}__input`}>
                <div className="sps-form-control sps-pagination__input-sizer">{inputPage}</div>
                <label htmlFor={id} className="sr-only">Page</label>
                <input id={id}
                    type="text"
                    value={inputPage}
                    onChange={() => {}}
                    onInput={onTextInputInput}
                    className="sps-form-control sps-pagination__input"
                />
            </div>
            <span className="sps-page-selector__total-pages" data-testid={`${testId}_page-count`}>of {Number.isNaN(numPages) ? "many" : numPages}</span>
            <div className="sps-pagination__navigation-buttons" data-testid={`${testId}__buttons`}>
                <div className={clsx("sps-btn", "sps-btn--icon", page === 1 && "disabled")}>
                    <button
                        onClick={() => updatePage(page - 1)}
                        disabled={page === 1}
                        
                        aria-label="Back"
                        title="Back"
                    >
                        <i className="sps-icon sps-icon-chevron-left" aria-hidden="true" />
                    </button>
                </div>
                <div className={clsx("sps-btn", "sps-btn--icon", page === numPages && "disabled")}>
                    <button
                        onClick={() => updatePage(page + 1)}
                        disabled={page === numPages}
                        aria-label="Next"
                        title="Next"
                    >
                        <i className="sps-icon sps-icon-chevron-right" aria-hidden="true" />
                    </button>
                </div>
            </div>
        </div>
    );
}

(SpsPageSelector as React.FC).propTypes = propTypes;
(SpsPageSelector as React.FC).displayName = "SpsPageSelector";
